import { render, staticRenderFns } from "./policy-table.vue?vue&type=template&id=33b41a6f"
import script from "./policy-table.vue?vue&type=script&lang=js"
export * from "./policy-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports